<template>
  <!-- v-if="section.seatLayout" -->
  <div
    :class="
      fullscreen
        ? 'pos-seatlayout-wrapper-fullscreen'
        : 'pos-seatlayout-wrapper'
    "
  >
    <header class="pos-seatlayout-header">
      <div class="row">
        <div class="col-5 align-self-center">
          <strong class="fs-22">{{ screenObj.screen_name }}</strong>
        </div>
        <div class="col-7 align-self-center">
          <div class="d-flex align-items-center w-100 justify-content-end">
            <!-- <p class="mb-0 pr-3">Multiselects Seats</p>
            <label class="ios-switch">
              <input v-model="isMultiSelectAllowed" type="checkbox" class="ios-checkbox" />
              <span class="switch-slider"></span>
            </label>-->
            <router-link class="btn-blue" to="/cinema-manager/schedule-comments"
              >{{ $tc("schedule", 2) }} {{ $tc("list", 1) }}</router-link
            >
          </div>
        </div>
      </div>

      <div class="row mx-0 pt-3 justify-content-between">
        <div class="d-flex justify-content-end align-items-center">
          <!-- <div v-for="(seatType, seatTypeIndex) in seatTypes" :key="seatTypeIndex" class="mx-1">
            <div class="cinema-seat my-0 mx-auto bg-blue" :class="seatType.imageClass"></div>
            <small>{{seatType.seatName}}</small>
          </div>-->
          <div class="mx-1">
            <div
              class="pos-seat my-0 regular-seat seat-fixed-width mx-auto bg-blue"
            ></div>
            <small>Regular {{ $tc("seat", 1) }}</small>
          </div>

          <div class="mx-1" style="position:relative;top:2px;">
            <div class="text-center mb-1">
              <img
                src="@/assets/img/pos/wheelchair.svg"
                height="auto"
                width="22"
                alt
              />
            </div>
            <small>{{ $t("wheelchair") }}</small>
          </div>

          <div class="mx-1">
            <div
              class="pos-seat my-0 vip-seat seat-fixed-width mx-auto bg-blue"
            ></div>
            <small>VIP {{ $tc("seat", 1) }}</small>
          </div>

          <div class="mx-1">
            <div class="pos-seat my-0 love-seat mx-auto bg-blue"></div>
            <small>{{ $t("love") }} {{ $tc("seat", 1) }}</small>
          </div>

          <div class="mx-1" style="position:relative;top:2px;">
            <!-- <div class="text-center mb-1">
              <img src="@/assets/img/icons/pointofsale.png" height="auto" width="22" alt />
            </div>-->
            <div class="pos-seat my-0 pointofsale-seat mx-auto bg-blue"></div>
            <small>{{ $t("onlyPos") }}</small>
          </div>

          <div class="mx-1">
            <div
              class="pos-seat my-0 regular-seat seat-fixed-width mx-auto bg-blue"
            ></div>
            <small>{{ $tc("Sofa", 1) }}</small>
          </div>

          <div class="mx-1">
            <div
              class="pos-seat my-0 recliner-seat seat-fixed-width mx-auto bg-blue"
            ></div>
            <small>{{ $t("recliner") }} {{ $tc("seat", 1) }}</small>
          </div>

          <div class="mx-1">
            <div
              class="pos-seat my-0 block-seat seat-fixed-width mx-auto"
            ></div>
            <small>{{ $tc("blockSeat", 1) }}</small>
          </div>

          <div class="mx-1" style="position:relative;top:2px;">
            <!-- <div class="text-center mb-1">
              <img src="@/assets/img/icons/broken-seat.jpg" height="auto" width="22" alt />
            </div>-->
            <div
              class="pos-seat my-0 broken-seat seat-fixed-width mx-auto bg-blue"
            ></div>
            <small>{{ $t("broken") }} {{ $tc("seat", 1) }}</small>
          </div>

          <div class="divider mx-1 mx-xl-3"></div>

          <div class="mx-1">
            <div class="pos-seat my-0 taken seat-fixed-width mx-auto"></div>
            <small>{{ $t("taken") }}</small>
          </div>

          <!-- <div class="mx-1">
            <div class="pos-seat my-0 your-selection seat-fixed-width mx-auto"></div>
            <small>{{ $t('your') }} {{ $t('selection') }}</small>
          </div>-->

          <!-- <div class="divider mx-1 mx-xl-3"></div> -->

          <!-- <div class="mx-1 mx-xl-3 text-center pr-2">
            <button class="btn-transparent mx-auto" v-on:click="showFullScreenFunc()">
              <img
                src="@/assets/img/icons/fullscreen-icon.svg"
                class="d-block mx-auto"
                height="20"
                width="20"
              />
              <small v-if="!fullscreen">{{ $t('full') }} {{ $tc('screen', 2) }}</small>
              <small v-if="fullscreen">{{ $t('exit') }} {{ $t('full') }} {{ $tc('screen', 2) }}</small>
            </button>
          </div>-->
        </div>
      </div>

      <!-- <div class="row pt-3" v-if="isMultiSelectAllowed">
        <div class="col-3 align-self-center">
          <h6 class="text-blue mb-0">Select no of seats:</h6>
        </div>
        <div class="col-9">
          <ul class="seatNumList list-inline pl-0 mb-0">
            <li
              class="list-inline-item"
              :class="totalNumberOfSeats == item ? 'active':''"
              @click="onSelectNumberOfSeats(item)"
              v-for="(item, itemKey) in 10"
              :key="itemKey"
            >{{ itemKey+1 }}</li>
          </ul>
        </div>
      </div>-->
    </header>

    <div :class="['pos-seatlayout']">
      <table v-for="(seat, seatIndex) in seatType" :key="seatIndex">
        <tr>
          <td colspan="30">
            <div
              class="relative pb-3"
              v-bind:class="{ hideScreen: seatIndex != 0 }"
            >
              <img
                src="@/assets/img/pos/pos-screen.png"
                class="img-fluid w-100"
              />
              <span class="eyes-text">{{ $t("screen_title") }}</span>
            </div>
          </td>
        </tr>
        <!-- REGULAR SEATS -->

        <!-- SLIVER CLASS LABEL -->
        <tr>
          <td colspan="22">
            <div class="pos-seat-class">
              {{ seat.seatType }}
              <strong
                >({{ seat.seat_price }} {{ currencyData.curr_code }})</strong
              >
            </div>
          </td>
        </tr>

        <tr
          v-for="(seatRow, seatRowIndex) in seat.seatsFinal"
          :key="seatRowIndex"
        >
          <!-- <td> -->
          <!-- <div class="text-center lh-1">{{seatRowIndex}}</div> -->
          <!-- </td> -->
          <!-- <td>
            <div class="pos-seatNumber">1</div>
            <div v-on:click="onClickSeatFunc()" class="pos-seat regular-seat your-selection"></div>
          </td>-->
          <!-- <td>
            <div class="pos-seatNumber">2</div>
            <div v-on:click="onClickSeatFunc()" class="pos-seat regular-seat your-selection"></div>
          </td>-->
          <td
            v-for="(singleSeat, singleSeatIndex) in seatRow"
            :key="'index' + singleSeatIndex"
            :class="
              singleSeat.sst_seat_type.toLowerCase() == 'sofa'
                ? 'lounger-container'
                : ''
            "
          >
            <!-- {{singleSeat.seat_reserve_type_id}} -->
            <div v-if="singleSeat.srt_id == 2" class="pos-seatNumber"></div>
            <div v-else class="pos-seatNumber">
              {{ singleSeat.sl_seat_name }}
            </div>
            <div
              v-if="singleSeat.seat_reserve_type_id == 5"
              class="pos-seat bg-blue vip-seat cursor-pointer"
              disabled
            ></div>
            <!-- v-on:click="handlerSeatSelected(singleSeat, seatRowIndex, singleSeatIndex, null, null, $event,seatIndex)"
            :class="singleSeat.selectStatus == true ? 'your-selection': singleSeat.seat_reserve_type_id == 5 ? 'bg-blue vip-seat' : 'normal-seat'"-->
            <div
              v-else
              disabled
              class="pos-seat cursor-pointer"
              :class="[
                singleSeat.selectStatus == true
                  ? 'your-selection'
                  : singleSeat.seat_reserve_type_id == 1
                  ? 'bg-blue regular-seat'
                  : singleSeat.seat_reserve_type_id == 3
                  ? 'bg-blue wheelchair'
                  : singleSeat.seat_reserve_type_id == 6
                  ? 'bg-blue love-seat'
                  : singleSeat.seat_reserve_type_id == 8
                  ? 'taken pointer-events'
                  : singleSeat.seat_reserve_type_id == 9
                  ? 'bg-blue pointofsale-seat'
                  : singleSeat.seat_reserve_type_id == 10
                  ? 'bg-blue normal-seat'
                  : singleSeat.seat_reserve_type_id == 11
                  ? 'bg-blue recliner-seat'
                  : singleSeat.seat_reserve_type_id == 12
                  ? 'block-seat'
                  : singleSeat.seat_reserve_type_id == 13
                  ? 'bg-blue pointer-events broken-seat'
                  : 'normal-seat',
                singleSeat.sst_seat_type.toLowerCase() == 'sofa'
                  ? 'lounger'
                  : '',
              ]"
            ></div>
            <!-- v-on:click="handlerSeatSelected(singleSeat, seatRowIndex, singleSeatIndex, null, null, $event,seatIndex)" -->
          </td>
          <!-- <td>
            <div class="text-center lh-1">{{seatRowIndex}}</div>
          </td>-->
        </tr>

        <!-- <tr v-for="(loop , regularSeatsRow) in 3" :key="regularSeatsRow">
          <td>
            <div v-if="regularSeatsRow == 0" class="text-center lh-1">A</div>
            <div v-if="regularSeatsRow == 1" class="text-center lh-1">B</div>
            <div v-if="regularSeatsRow == 2" class="text-center lh-1">C</div>
          </td>
          <td v-for="(loop , regularSeats) in 20" :key="regularSeats">
            <div class="pos-seatNumber">{{regularSeats}}</div>
            <div v-on:click="onClickSeat()" class="pos-seat regular-seat"></div>
          </td>
          <td>
            <div v-if="regularSeatsRow == 0" class="text-center lh-1">A</div>
            <div v-if="regularSeatsRow == 1" class="text-center lh-1">B</div>
            <div v-if="regularSeatsRow == 2" class="text-center lh-1">C</div>
          </td>
        </tr>-->

        <!-- GOLD CLASS LABEL-->
        <!-- <tr>
          <td colspan="22">
            <div class="pos-seat-class">
              Gold Class
              <strong>(300 AED)</strong>
            </div>
          </td>
        </tr>-->

        <!-- <tr v-for="(loop , vipSeatsRow) in 3" :key="vipSeatsRow">
          <td>
            <div v-if="vipSeatsRow == 0" class="text-center lh-1">D</div>
            <div v-if="vipSeatsRow == 1" class="text-center lh-1">E</div>
            <div v-if="vipSeatsRow == 2" class="text-center lh-1">F</div>
          </td>
          <td>
            <div class="pos-seatNumber">0</div>
            <div class="pos-seat wheelchair"></div>
          </td>
          <td v-for="(loop , vipSeatKey) in 19" :key="vipSeatKey">
            <div class="pos-seatNumber">{{vipSeatKey}}</div>
            <div class="pos-seat vip-seat"></div>
          </td>
          <td>
            <div v-if="vipSeatsRow == 0" class="text-center lh-1">D</div>
            <div v-if="vipSeatsRow == 1" class="text-center lh-1">E</div>
            <div v-if="vipSeatsRow == 2" class="text-center lh-1">F</div>
          </td>
        </tr>-->

        <!-- RECLINER CLASS LABEL-->
        <!-- <tr>
          <td colspan="22">
            <div class="pos-seat-class">
              Recliner Class
              <strong>(500 AED)</strong>
            </div>
          </td>
        </tr>-->

        <!-- <tr v-for="(loop , recliner) in 2" :key="recliner">
          <td>
            <div v-if="recliner == 0" class="text-center lh-1">G</div>
            <div v-if="recliner == 1" class="text-center lh-1">H</div>
          </td>
          <td colspan="2" v-for="(loop , loveSeatKey) in 10" :key="loveSeatKey">
            <div class="pos-seatNumber">{{loveSeatKey}}</div>
            <div class="pos-seat love-seat"></div>
          </td>
          <td>
            <div v-if="recliner == 0" class="text-center lh-1">G</div>
            <div v-if="recliner == 1" class="text-center lh-1">H</div>
          </td>
        </tr>-->
      </table>
    </div>

    <!-- <b-button v-b-modal.seat_select_modal>Select Seat</b-button> -->
    <!-- <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      ref="seat_select_modal"
      id="seat_select_modal"
      class="seat_select_modal"
    >
      <div class="text-center pt-4">
        <h5 class="font-weight-bold text-blue mb-3">How many seats you want to book ?</h5>
        <ul class="seatNumList list-inline pl-0 mb-0 pt-2">
          <li
            class="list-inline-item"
            v-for="(item, itemKey) in 10"
            :key="itemKey"
            :class="totalNumberOfSeats == item ? 'active':''"
            @click="onSelectNumberOfSeats(item)"
          >{{ itemKey+1 }}</li>
        </ul>
      </div>
    </b-modal>-->
  </div>
</template>
<script>
  import ScreenService from "@/services/ScreenService";
  import MasterService from "@/services/MasterService";
  import UserService from "@/services/UserService";
  import PosService from "@/services/PosService";

  import { groupBy } from "lodash";

  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    // name: "Schedule Seat Layout",
    data() {
      return {
        screenObj: {},
        seatLayoutData: [],
        currencyData: [],
        fullscreen: true,
        selectedSeats: [],
        selectionType: "Bulk", //Bulk,
        no_of_seats: 3,

        selectedVipSeatObject: {},
        seatTypes: [
          {
            seatName: "Regular Seat",
            size: 1,
            value: 1,
            imageClass: "regular-seat",
          },
          {
            seatName: "No Seat",
            size: 1,
            value: 2,
            imageClass: "no-seat",
          },
          {
            seatName: "Wheel Chair",
            size: 1,
            value: 3,
            imageClass: "wheelchair",
          },
          {
            seatName: "VIP Seat",
            size: 1,
            value: 5,
            imageClass: "vip-seat",
          },
          // {
          //   seatName: "LoveSeat",
          //   size: 6,
          //   imageClass: "love-seat",
          // },
          {
            seatName: "Only POS",
            size: 1,
            value: 9,
            imageClass: "pointofsale",
          },
          {
            seatName: "Sofa",
            size: 1,
            value: 10,
            imageClass: "regular-seat",
          },
          {
            seatName: "Recliner",
            size: 1,
            value: 11,
            imageClass: "recliner",
          },
          {
            seatName: "Blocked Seat",
            size: 1,
            value: 12,
            imageClass: "block-seat",
          },
        ],
      };
    },
    computed: {
      seatType() {
        return this.seatLayoutData;
      },
    },
    mounted() {
      const { ss_id, md_id, screen_id } = this.$route.params;
      this.getScreenData(screen_id);
      this.GET_SEAT_LAYOUT({ ss_id, md_id, screen_id });
      this.getCurrencyCode();
    },

    methods: {
      async GET_SEAT_LAYOUT(payload) {
        console.log("payload :", payload);
        let loader = this.$loading.show();
        let data = {};
        let seats = await PosService.PosGetSeatLayout({
          screen_id: payload.screen_id,
          ss_id: payload.ss_id,
          md_id: payload.md_id,
        });
        data.seats = seats.data;
        let seatType = await PosService.getSeatType({
          screen_id: payload.screen_id,
          ss_id: payload.ss_id,
          md_id: payload.md_id,
        });

        data.seatType = seatType.data;
        //   console.log("data :", seats);
        loader.hide();
        if (seats && seats.status) {
          let seatData = [];
          let seatData1 = groupBy(data.seats.Records, "sst_seat_type");
          data.seatType.Records = data.seatType.Records.sort(function(a, b) {
            return a.sst_order - b.sst_order;
          });
          data.seatType.Records.map((type) => {
            for (var key in seatData1) {
              if (seatData1.hasOwnProperty(key)) {
                // console.log(key + " -> " + seatData1[key]);
                if (key == type.sst_seat_type) {
                  seatData[key] = seatData1[key];
                }
              }
            }
            // seatData.seat
          });
          let tempArray = [];
          for (let key in seatData) {
            if (seatData.hasOwnProperty(key)) {
              let seat_price = 0;
              let seat_price_obj = seatData[key].filter((x) => {
                return x;
              });
              // console.log('seat_price_obj :', seat_price_obj);
              if (seat_price_obj) {
                seat_price = seat_price_obj[0].seat_price;
              }
              // console.log('seat_price :', seat_price);
              tempArray.push({
                seatType: key,
                seat_price: seat_price,
                seats: seatData[key],
              });
            }
          }
          // let finalTempArray = [];
          // tempArray.map(item=>{
          //   let tempArray1 = [];
          //   let newtempArray =groupBy(item,"")
          // })
          let finalArray = [];

          // [{
          //   seatType: 'gold',
          //   seats: []
          // }]

          for (let i = 0; i < tempArray.length; i++) {
            let singleSeatType = tempArray[i];

            let seatData_1 = groupBy(singleSeatType.seats, "sl_row_num");
            // seatData_1 = {
            //   0: [],
            //   1: []
            // }
            let tempArray_1 = [];
            for (let key in seatData_1) {
              if (seatData_1.hasOwnProperty(key)) {
                let seatData_2 = seatData_1[key].map((singleSeat) => {
                  singleSeat.selectStatus = false;
                  singleSeat.SelectStatusFlag = false;
                  return singleSeat;
                });
                seatData_2 = seatData_2.sort(function(a, b) {
                  return a.sl_col_num - b.sl_col_num;
                });

                tempArray_1.push(seatData_2);
              }
            }
            // console.log('tempArray_1 before', tempArray_1)

            // console.log('tempArray_1 after', tempArray_1)
            // tempArray_1 = [[], []]
            tempArray[i].seatsFinal = tempArray_1;
            // finalArray.push({ seatType: tempArray, seats: tempArray_1 })
          }
          this.seatLayoutData = tempArray;
        } else {
          this.$toasted.show(data.message || "Please try later");
        }
      },
      getCurrencyCode: function() {
        let payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
          curr_id:
            this.secureStore.get("BRGLOPCU") &&
            this.secureStore.get("BRGLOPCU").go_value,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.currencyData = data.Records[0];
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      },
      getScreenData: function(screen_id) {
        let payload = {
          tableName: "screens",
          screen_id: screen_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.screenObj = data.Records[0];
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getScreenData :", error);
          });
      },
    },
  };
</script>

<style scoped>
  /* .hideScreen {
  height: 0;
  opacity: 0;
  overflow: hidden;
  visibility: hidden;
  margin-bottom: 0 !important;
} */
  .normal-seat {
    display: none !important;
  }

  .seatNumList li {
    height: 35px;
    width: 35px;
    color: #ffffff;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    border-radius: 50%;
    align-items: center;
    display: inline-flex;
    justify-content: center;
    background-color: #979797;
  }

  .seatNumList li.active,
  .seatNumList li:hover {
    background-color: var(--blue);
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScheduleCommentsComponent/scheduleSeatLayout.vue